import { SiteBody } from "@vviinn/user-managment-client-ts";

import { EmbedderConfig } from "../types";

import { defaultSegmentations, embedderTitles } from "../constants";

import { embedderTitleToAiTitle } from "./embedderTitleToAiTitle";

export const configWithSegmentation = (initialConfig: SiteBody) => {
  const embedderConfig: EmbedderConfig[] = [];
  embedderTitles.forEach((title) => {
    const formattedTitle = embedderTitleToAiTitle(title);
    const isPredefined = initialConfig?.embedders?.find(
      ({ name }) => name === title,
    );
    if (isPredefined) {
      embedderConfig.push({ aiTitle: formattedTitle, ...isPredefined });
    } else {
      const isActive = initialConfig[formattedTitle] ?? false;
      const useSegmentation = defaultSegmentations.includes(title);
      embedderConfig.push({
        name: title,
        active: isActive,
        useSegmentation,
        aiTitle: formattedTitle,
      });
    }
  });
  return embedderConfig;
};
